import React from "react";
import Slider from "react-slick";
import linkedinImg from "../../assets/social_icons/linkedin.png"
import email_ from "../../assets/social_icons/email.png"
import phoneImg from "../../assets/social_icons/phone.png"
import whatsapp from "../../assets/social_icons/whatsapp.png"
import facebookp from "../../assets/social_icons/facebook.png"
import instagramp from "../../assets/social_icons/instagram.png"
import twitterp from "../../assets/social_icons/xlogo.png"
import videop from "../../assets/social_icons/video.png"
import microsoftteamsp from "../../assets/social_icons/microsoftteams.png"
import ar_logo from "../../assets/social_icons/ra.png"
import power_logo from "../../assets/social_icons/powerpoint.png"
import word_logo from "../../assets/social_icons/word.png"
import excel_logo from "../../assets/social_icons/excel.png"
import pdf_logo from "../../assets/social_icons/pdf.png"
import { resolveWhatsappPhone } from "../../functions/solvimasGroup"

export default function CarouselContainer({
    socialStyle,
    imageStyle,
    sliderSettings,
    email,
    phone,
    linkedin,
    microsoftteams,
    facebook,
    instagram,
    twitter,
    video,
    animated,
    typeOfDevice,
    augmented_reality,
    silderStyle,
    cardStyle,
    labelStyle,
    excel,
    powerpoint,
    pdf,
    word,
    projectId
}) {
    const whatsappPhone = resolveWhatsappPhone({ projectId, email, phone });

    return (
        <Slider className={silderStyle} {...sliderSettings}>
            <div className={cardStyle}>
                <p className={labelStyle}>Teléfono</p>
                <a className={socialStyle} href={"tel:" + phone}>
                    <img src={phoneImg} className={imageStyle} alt="Teléfono" />
                </a>
            </div>
            <div className={cardStyle}>
                <p className={labelStyle}>WhatsApp</p>
                <a
                    className={socialStyle + ` ${animated?.whats_animated && 'animate-bounce'} `} href={"https://wa.me/" + whatsappPhone}>
                    <img src={whatsapp} className={imageStyle} alt="Whatsapp" />
                </a>
            </div>
            <div className={cardStyle}>
                <p className={labelStyle}>Email</p>
                <a
                    className={socialStyle} href={"mailto:" + email}>
                    <img src={email_} className={imageStyle} alt="Email" />
                </a>
            </div>
            {linkedin &&
                <div className={cardStyle}>
                    <p className={labelStyle}>LinkedIn</p>
                    <a className={socialStyle} href={linkedin.includes("https://www.linkedin.com/in") ? linkedin : "https://www.linkedin.com/in/" + linkedin}>
                        <img src={linkedinImg} className={imageStyle} alt="Linkedin" />
                    </a>
                </div>}
            {facebook &&
                <div className={cardStyle}>
                    <p className={labelStyle}>Facebook</p>
                    <a className={socialStyle} href={
                        typeOfDevice === "Android" ? (facebook.includes("https://www.facebook.com/") ? `fb://facewebmodal/f?href=${facebook}` : `fb://facewebmodal/f?href=https://www.facebook.com/${facebook}/`) : (
                            typeOfDevice === "iOS" ? (facebook.includes("https://www.facebook.com/") ? `fb://profile/${facebook.replace("https://www.facebook.com/", "")}` : `fb://profile/${facebook}`) : (facebook.includes("https://www.facebook.com/") ? `${facebook}` : `https://www.facebook.com/${facebook}/`)
                        )
                    } >
                        <img src={facebookp} className={imageStyle} alt="Facebook" />
                    </a>
                </div>}
            {instagram &&
                <div className={cardStyle}>
                    <p className={labelStyle}>Instagram</p>
                    <a className={socialStyle} href={instagram.includes("https://www.instagram.com/") ? `${instagram}` : `https://instagram.com/${instagram}`} >
                        <img src={instagramp} className={imageStyle} alt="Instagram" />
                    </a>
                </div>}
            {twitter &&
                <div className={cardStyle}>
                    <p className={labelStyle}>X (Twitter)</p>
                    <a className={socialStyle} href={twitter.includes("https://twitter.com/") ? `${twitter}` : `https://twitter.com/${twitter}`}>
                        <img src={twitterp} className={imageStyle} alt="Twitter" />
                    </a>
                </div>}
            {video &&
                <div className={cardStyle}>
                    <p className={labelStyle}>VIDEO</p>
                    <a className={socialStyle} href={`${video}`} target="_blank" rel="noreferrer">
                        <img src={videop} className={imageStyle} alt="VIDEO" />
                    </a>
                </div>}
            {microsoftteams &&
                <div className={cardStyle}>
                    <p className={labelStyle}>MS TEAMS</p>
                    <a className={socialStyle}
                        href={microsoftteams.includes("https://teams.microsoft.com/l/") ? microsoftteams : "https://teams.microsoft.com/l/" + microsoftteams}
                        target="_blank"
                        rel="noreferrer">
                        <img src={microsoftteamsp} className={imageStyle} alt="MICROSOFT TEAMS" />
                    </a>
                </div>}
            {augmented_reality &&
                <div className={cardStyle}>
                    <p className={labelStyle}>RA</p>
                    <a className={socialStyle} href={`${augmented_reality}`} target="_blank" rel="noreferrer">
                        <img src={ar_logo} className={imageStyle} alt="Realidad Aumentada" />
                    </a>
                </div>}
            {powerpoint &&
                <div className={cardStyle}>
                    <p className={labelStyle}>PowerPoint</p>
                    <a className={socialStyle} href={`${powerpoint}`} target="_blank" rel="noreferrer">
                        <img src={power_logo} className={imageStyle} alt="PowerPoint" />
                    </a>
                </div>}
            {word &&
                <div className={cardStyle}>
                    <p className={labelStyle}>Word</p>
                    <a className={socialStyle} href={`${word}`} target="_blank" rel="noreferrer">
                        <img src={word_logo} className={imageStyle} alt="Word" />
                    </a>
                </div>}
            {excel &&
                <div className={cardStyle}>
                    <p className={labelStyle}>Excel</p>
                    <a className={socialStyle} href={`${excel}`} target="_blank" rel="noreferrer">
                        <img src={excel_logo} className={imageStyle} alt="Excel" />
                    </a>
                </div>}
            {pdf &&
                <div className={cardStyle}>
                    <p className={labelStyle}>PDF</p>
                    <a className={socialStyle} href={`${pdf}`} target="_blank" rel="noreferrer">
                        <img src={pdf_logo} className={imageStyle} alt="PDF" />
                    </a>
                </div>}
        </Slider>
    );
}
